import { render, staticRenderFns } from "./ContentDetailPanel.vue?vue&type=template&id=90b52bea&scoped=true"
import script from "./ContentDetailPanel.vue?vue&type=script&lang=js"
export * from "./ContentDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./ContentDetailPanel.vue?vue&type=style&index=0&id=90b52bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b52bea",
  null
  
)

export default component.exports